var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWashroominline = function SvgWashroominline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "washroom_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".washroom_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7873_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7881_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7882_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7883_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7884_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "washroom_inline_svg__XMLID_7885_",
    d: "m18.4 25.9-.7-.3-2.3 2.4-2.4-2.4-.7.3c-1.6.8-3.4 2.2-3.4 5v3.9h12.8v-3.9c.1-2.8-1.7-4.1-3.3-5zm1.4 6.9H11v-1.9c0-1.2.5-2.1 1.7-2.8l2.7 2.7 2.7-2.7c1.2.8 1.7 1.6 1.7 2.8v1.9z",
    className: "washroom_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7889_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7890_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7891_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "washroom_inline_svg__XMLID_7892_",
    d: "M20 24.1c-.2.3-.6.6-.9.7l-2.5.6-.5-1.9 2-.5-.7-3.1c-.2-.9-1.1-1.6-2-1.6s-1.8.7-2 1.6l-.7 3.1 2.2.5-.5 1.9-2.7-.6c-.4-.1-.7-.3-.9-.7-.2-.3-.3-.7-.2-1.1l.8-3.6c.4-1.8 2.1-3.2 4-3.2s3.5 1.3 4 3.1l.8 3.6c.1.4 0 .8-.2 1.2z",
    className: "washroom_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7894_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7895_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7896_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "washroom_inline_svg__XMLID_7897_",
    d: "M34.6 17.1c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7 3.7-1.7 3.7-3.7-1.7-3.7-3.7-3.7zm0 5.4c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7z",
    className: "washroom_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7901_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7902_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "washroom_inline_svg__XMLID_7904_",
    d: "m37.6 25.9-.6-.3-2.4 2.4-2.4-2.4-.7.3c-1.6.8-3.4 2.2-3.4 5v3.9H41v-3.9c0-2.8-1.8-4.1-3.4-5zm1.4 6.9h-8.8v-1.9c0-1.2.5-2.1 1.7-2.8l2.7 2.7 2.7-2.7c1.2.8 1.7 1.6 1.7 2.8v1.9z",
    className: "washroom_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7908_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7909_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "washroom_inline_svg__XMLID_7910_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "washroom_inline_svg__XMLID_7911_",
    d: "M26 11.8v27.5c0 .6-.4 1-1 1s-1-.4-1-1V11.8c0-.5.4-1 1-1 .5 0 1 .4 1 1z",
    className: "washroom_inline_svg__st1"
  }))))))));
};
export default SvgWashroominline;